module.exports = __webpack_public_path__ + "static/media/02.c91e8373.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/02.png
// module id = 173
// module chunks = 0